import { apiPost } from './apiClient';

// Cancel a payment
export const cancelPayment = async (paymentId, cancelData) => {
  try {
    const response = await apiPost(`/payments/${paymentId}/cancel`, cancelData);
    return response.data;
  } catch (error) {
    console.error('Error cancelling payment:', error);
    throw error;
  }
};
